"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useGetSelectedAccount;

var _reactRedux = require("react-redux");

var _reduxForm = require("redux-form");

function useGetSelectedAccount(accounts) {
  var formData = (0, _reactRedux.useSelector)((0, _reduxForm.getFormValues)('transfer-create'));

  if (formData && 'account' in formData && formData['account']) {
    return formData['account'];
  }

  return accounts.length ? accounts[0] : null;
}